<div class="gallery-admin">

    <div class="top-bar">

        <h1>Gallery CMS</h1>

        <button class="upload-btn" (click)="fileInput.click()">
            + Upload Image
        </button>

        <input
            #fileInput
            hidden
            type="file"
            accept="image/*"
            (change)="uploadImage($event)">

    </div>

    <div class="editor" *ngIf="gallery.imageUrl">

        <div class="preview">

            <img [src]="gallery.imageUrl">

        </div>

        <div class="form">

            <label>Title</label>

            <input
                type="text"
                [(ngModel)]="gallery.title">

            <div class="buttons">

                <button
                    class="save"
                    (click)="save()"
                    [disabled]="saving || uploading">

                    {{ selectedImageId ? 'Update' : 'Save' }}

                </button>

                <button
                    *ngIf="selectedImageId"
                    class="cancel"
                    (click)="clearForm()">

                    Cancel

                </button>

            </div>

        </div>

    </div>

    <div class="gallery-grid">

        <div
            class="card"
            *ngFor="let image of images">

            <img
                [src]="image.imageUrl"
                [alt]="image.title">

            <div class="overlay">

                <button
                    type="button"
                    (click)="edit(image)">
                    ✏
                </button>

                <button
                    type="button"
                    (click)="delete(image.id)">
                    🗑
                </button>

            </div>

            <h4>{{ image.title }}</h4>

        </div>

    </div>

</div>